// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".name[data-v-7b9d79d6] {\n  line-height: 35px;\n  text-align: center;\n  margin-bottom: 20px;\n  font-size: 18px;\n  font-weight: bold;\n}\n[data-v-7b9d79d6] .ant-timeline p {\n  margin-left: 0;\n}\n.color[data-v-7b9d79d6] {\n  color: #999;\n}", ""]);
// Exports
module.exports = exports;
